module.exports = __webpack_public_path__ + "static/media/CJ_Maths_CoverImg.90cd5539.png";